import "./App.scss";
import { Col, Row } from "react-bootstrap";
import { UserPreferencesButton } from "./UserPreferences";
import { getEnv } from "./App";

export function AppHeader({ username }: { username: string | undefined }) {
    return (
        <div className={"container-fluid"}>
            <Row lg={12} className="app-header text-nowrap">
                <Col>
                    <Row className="container-fluid" style={{ alignItems: "center" }}>
                        <Col className="app-header__logo text-nowrap">
                            <img
                                src="/asset-logo-blue.svg"
                                alt="Asset Ingest Tool Logo"
                            />
                            <div className="app-header__title align-middle">
                                Asset Ingest Tool {getEnv()}
                            </div>
                        </Col>
                        <Col className="app-header__user text-nowrap">
                            <UserPreferencesButton />
                            {username ?? "no username"}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}
